const actions = {
  setLang: (context, value) => {
    context.commit('SET_LANG', value);
  },
  setLongLang: (context, value) => {
    context.commit('SET_LONG_LANG', value);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/lang/actions.js